import { create } from 'zustand';

/**
 * AI 探索模式状态（Phase 2 Week 7）
 * 独立于阅读器 store；Phase 2 Week 8 将并入共享状态层。
 */

export type ExplorerView = 'atlas' | 'world';

export interface ExplorerPageNode {
  pageNumber: number;
  title: string;
  content: string;
  interactionCount: number;
  sceneElementCount: number;
}

export interface ExplorerState {
  /** 当前视图：atlas = 星空书库，world = 单本书探索 */
  view: ExplorerView;
  /** atlas 中选中的书籍 slug */
  selectedBookSlug: string | null;
  /** world 视图中聚焦的页面节点 */
  focusedPage: number;
  /** 探索历史（页面节点），用于返回上级 */
  exploreHistory: number[];

  enterAtlas: () => void;
  enterBook: (slug: string) => void;
  exitBook: () => void;
  focusPage: (pageNumber: number) => void;
  pushExploration: (pageNumber: number) => void;
  popExploration: () => void;
}

export const useExplorerStore = create<ExplorerState>((set) => ({
  view: 'atlas',
  selectedBookSlug: null,
  focusedPage: 1,
  exploreHistory: [],

  enterAtlas: () => set({ view: 'atlas', selectedBookSlug: null, exploreHistory: [] }),
  enterBook: (slug) => set({ view: 'world', selectedBookSlug: slug, focusedPage: 1, exploreHistory: [] }),
  exitBook: () => set({ view: 'atlas', selectedBookSlug: null, exploreHistory: [] }),
  focusPage: (pageNumber) => set({ focusedPage: pageNumber }),
  pushExploration: (pageNumber) =>
    set((s) => ({ exploreHistory: [...s.exploreHistory, s.focusedPage], focusedPage: pageNumber })),
  popExploration: () =>
    set((s) => {
      const history = [...s.exploreHistory];
      const prev = history.pop();
      return { exploreHistory: history, focusedPage: prev ?? 1 };
    }),
}));

/**
 * 探测 WebGL 可用性（R3F Canvas 前置判断，避免白屏）
 * 云端沙箱 GPU 禁用时返回 false，走 2D 星图降级。
 */
export function isWebGLAvailable(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl2') ||
      canvas.getContext('webgl') ||
      (canvas.getContext('experimental-webgl') as WebGLRenderingContext | null);
    return !!gl;
  } catch {
    return false;
  }
}